import React from "react";
import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";
import { useContent } from "../context/ContentContext";

const ease = [0.16, 1, 0.3, 1];

export const Hero = () => {
  const { content } = useContent();
  const { company: COMPANY, hero } = content;
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center overflow-hidden bg-paper"
    >
      {/* Right architectural image */}
      <div className="absolute inset-y-0 right-0 w-full md:w-1/2 h-full">
        <motion.img
          initial={{ scale: 1.15, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 1.6, ease }}
          src={hero.image}
          alt="Infissi su misura"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-paper via-paper/30 to-transparent md:from-paper md:via-paper/10" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 w-full pt-28 md:pt-0">
        <div className="max-w-2xl">
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2, ease }}
            className="eyebrow mb-6"
          >
            {hero.eyebrow} — Dal {COMPANY.since}
          </motion.p>

          <motion.h1
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.32, ease }}
            className="font-serif font-light leading-[0.95] text-5xl sm:text-6xl lg:text-7xl text-navy"
          >
            {hero.titleTop}
            <br />
            <span className="italic text-gold">{hero.titleEmphasis}</span> {hero.titleEnd}
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.5, ease }}
            className="mt-8 text-base md:text-lg text-navy/70 leading-relaxed max-w-lg"
          >
            {hero.subtitle}
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, delay: 0.66, ease }}
            className="mt-10 flex flex-col sm:flex-row gap-4"
          >
            <a
              href="#contatti"
              data-testid="hero-quote-btn"
              className="group inline-flex items-center justify-center gap-3 bg-navy text-paper px-8 py-4 text-xs uppercase tracking-[0.22em] hover:bg-gold transition-colors duration-400"
            >
              {hero.ctaPrimary}
            </a>
            <a
              href="#processo"
              data-testid="hero-process-btn"
              className="inline-flex items-center justify-center gap-3 border border-navy/30 text-navy px-8 py-4 text-xs uppercase tracking-[0.22em] hover:border-gold hover:text-gold transition-colors duration-400"
            >
              {hero.ctaSecondary}
            </a>
          </motion.div>
        </div>
      </div>

      <motion.a
        href="#chi-siamo"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2, duration: 1 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 text-navy/50"
      >
        <span className="text-[0.6rem] uppercase tracking-[0.3em]">Scorri</span>
        <motion.span animate={{ y: [0, 8, 0] }} transition={{ repeat: Infinity, duration: 1.8 }}>
          <ArrowDown size={16} />
        </motion.span>
      </motion.a>
    </section>
  );
};
